module.exports = __webpack_public_path__ + "img/shared2.afdc646a.png";